/**
 * The tunnel protocol of a VPN app device, as the admin device views show it
 * (the badges of doc 28 §8: `IKEv2` · `WireGuard` · `Secure Access (QUIC)`).
 *
 * The API labels a device in an Access device group `tunnelProtocol: "access"`
 * with `plane: "v3"` (VSNP-1626). A v2 device reads "wireguard" or "ikev2" and
 * carries no plane, so it is shown exactly as before.
 */

export interface AppDeviceProtocolFields {
  tunnelProtocol?: string | null;
  plane?: string | null;
}

/** The device tunnels through an Access Gateway (the v3 plane, QUIC). */
export function isAccessPlaneDevice(device: AppDeviceProtocolFields): boolean {
  return device.plane === 'v3' || device.tunnelProtocol === 'access';
}

/**
 * The label for a device's tunnel protocol. `long` spells IKEv2 out as
 * "IKEv2/IPsec" (the device detail page); `short` is for table columns.
 */
export function appDeviceProtocolLabel(device: AppDeviceProtocolFields, style: 'short' | 'long' = 'short'): string {
  if (isAccessPlaneDevice(device)) return 'Secure Access (QUIC)';
  if (device.tunnelProtocol === 'ikev2') return style === 'long' ? 'IKEv2/IPsec' : 'IKEv2';
  return 'WireGuard';
}
